import { Modal } from 'antd';
import useThemes from 'hooks/useThemes';
import CloseIcon from 'assets/icons/CloseIcon';
import { useAppTranslation } from 'app/hooks';

interface OnramperModalProps {
  isShow: boolean;
  onCancel?: () => void;
  onramperLink: string;
}

const OnramperModal: React.FunctionComponent<OnramperModalProps> = ({
  isShow,
  onCancel,
  onramperLink,
}) => {
  const { currentTheme } = useThemes();
  const t = useAppTranslation();

  return (
    <Modal
      className="common-modal deposit-modal onramper-modal"
      title={t('vinpay.connectModal.buyCrypto')}
      visible={isShow}
      onCancel={onCancel}
      footer={null}
      centered
      maskClosable={false}
      closeIcon={<CloseIcon isDarkMode={currentTheme === 'dark'} width="20" height="20" />}
      width={450}
      zIndex={1100}
    >
      <div className={`center-content-col gap-3 `}>
        <iframe
          src={onramperLink}
          title="Onramper Widget"
          height="630px"
          width="100%"
          allow="accelerometer; autoplay; camera; gyroscope; payment"
        />
      </div>
    </Modal>
  );
};

export default OnramperModal;
